import Hero from '../components/Hero';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';

const Home = ({ onWaitlistClick, onDemoClick }) => {
  return (
    <>
      <Hero onWaitlistClick={onWaitlistClick} onDemoClick={onDemoClick} />
      <Features />
      <HowItWorks />
      <Pricing onWaitlistClick={onWaitlistClick} />
      <FAQ />
    </>
  );
};

export default Home;
